import { AnyAction, combineReducers } from '@reduxjs/toolkit'

import favorites from 'store/slices/favorites'
import localProductsList from 'store/slices/localProductsList'

import { appReducer as app } from '@/app/model/slice/appSlice'

import { lotteryApi } from '@/screens/promo-lottery/api/form-request'

import { accessoriesOfferReducer } from '@/features/cart/accessories-offer/model/accessories-offer-slice'
import compare from '@/features/compare/model/compareSlice'

import { cartReducer as cart } from '@/entities/cart'
import { OrderSchema } from '@/entities/order/model/order-schema'
import { sessionReducer as session } from '@/entities/session'
import { userReducer as user } from '@/entities/user'

import { apiSlice } from '@/shared/api/apiSlice'

import address from './slices/address'
import burger from './slices/burger'
import categories from './slices/categories'
import header from './slices/header'

export const sharedReducers = {
	address,
	accessoriesOffer: accessoriesOfferReducer,
	cart,
	categories,
	compare,
	favorites,
	header,
	burger,
	localProductsList,
	[apiSlice.reducerPath]: apiSlice.reducer,
	[lotteryApi.reducerPath]: lotteryApi.reducer,
	app,
	user,
	session
}

const combinedReducer = combineReducers(sharedReducers)

export type SharedRootState = ReturnType<typeof combinedReducer>

export const rootReducer = (state: SharedRootState, action: AnyAction) => combinedReducer(state, action)
// Compatibility type for modules that still import order selectors/types from `store/rootReducer`.
export type RootState = SharedRootState & {
	order?: OrderSchema
}
